import { FEATURE_FLAGS, useFeatureFlagStatus } from '@/modules/featureFlags'

/**
 * Whether the current user sees the new Mobility Manager theme. It is on when the
 * `mobility_theme` feature flag is on for their organization (and region, if the flag row has
 * one). `isPending` is true until the flags are loaded.
 *
 * Left it here in case needed for local development to manually turn the feature flag on or off.
 */
export const useMobilityTheme = (): { isEnabled: boolean; isPending: boolean } =>
  useFeatureFlagStatus(FEATURE_FLAGS.MOBILITY_THEME)
